import { Navigate, useParams } from 'react-router-dom';

import { useAssignedTenantIdFromParams } from '@eluve/session-helpers';

export const TenantSettingsRedirect = ({ to }: { to: string }) => {
  const tenantId = useAssignedTenantIdFromParams();
  return <Navigate to={`/organizations/${tenantId}/settings/${to}`} replace />;
};

const ADMIN_PATH_TO_SETTINGS_PATH: Record<string, string> = {
  general: 'organization',
  users: 'members',
  layers: 'organization/layers',
};

export const AdminToSettingsRedirect = () => {
  const tenantId = useAssignedTenantIdFromParams();
  const [head = '', ...rest] = (useParams()['*'] ?? '')
    .split('/')
    .filter(Boolean);
  const mappedHead =
    head === '' ? 'organization' : (ADMIN_PATH_TO_SETTINGS_PATH[head] ?? head);
  const target = [mappedHead, ...rest].join('/');
  return (
    <Navigate to={`/organizations/${tenantId}/settings/${target}`} replace />
  );
};

export const OutputTemplatesToSettingsRedirect = () => {
  const tenantId = useAssignedTenantIdFromParams();
  const splat = useParams()['*'] ?? '';
  return (
    <Navigate
      to={`/organizations/${tenantId}/settings/templates${splat ? `/${splat}` : ''}`}
      replace
    />
  );
};
